
import { defineComponent, ref, onMounted, PropType, computed } from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import stc from "string-to-color";
import { useMessage , useThemeVars} from "naive-ui";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import statusModel from "@/core/models/share/status.interface";
import hosterResponseModalCurrentStatus from "@/components/hoster/hosterResponseModalCurrentStatus.vue";
import hosterResponseModalResolution from "@/components/hoster/hosterResponseModalResolution.vue";
import hosterResponseModalFinish from "@/components/hoster/hosterResponseModalFinish.vue";
import { useStore } from "vuex";
import {
  Module as HosterModule,
  Actions as HosterActions,
  Getters as HosterGetters,
} from "@/store/enums/hosterEnums";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
} from "@/store/enums/paramsEnums";
import { changeColor } from 'seemly'

export default defineComponent({
  name:"hosterResponseModal",
  props: {
    showModal: Boolean,
    event: { type: Object as PropType<inviteEventModel | null> , default: [],
      required: true,},
  },
  components: {
    HosterResponseModalCurrentStatus: hosterResponseModalCurrentStatus,
    HosterResponseModalResolution: hosterResponseModalResolution,
    HosterResponseModalFinish: hosterResponseModalFinish,
  },
  emits: ["showModalClose"],
  setup(props: any, context: any) {
    const store = useStore();
    const message = useMessage();
    const themeVars = useThemeVars();
    const showConfirmModal = ref<boolean>(false);
    const resolution = computed<inviteEventModel>(
      () => store.getters[HosterModule.desc + HosterGetters.Resolution]
    );
    const bodyStyle = {
      width: "1000px",
    };
    const contentStyle = {
      'padding-top': '15px',
    };
    const headerStyle =
    {
      background: "#EDEFF2",
      border: "radius",
      color:  "#fff",
      type: themeVars.value.infoColor
    };
    const statusData = computed<Array<statusModel>>(
      () => store.getters[Module.desc + Getters.EventStatuses]
    );
    const defaultTab = 0;

    //const selectedTab = ref<string>(defaultTab);
    const selectedTab = ref(0);

    function onClose(params: any) {
      if(resolution.value.Status == "O"){
        store.dispatch(
          HosterModule.desc + HosterActions.ResetResolution,
          resolution.value
        );
      }
      context.emit("showModalClose", false);
      store.dispatch(Module.desc + Actions.HandMyHostingEvents);
      setTimeout(() => (selectedTab.value = defaultTab), 1000);
    }

    function onReadyToSubmit(params: any) {
      if (resolution.value.FianlSchedularId && resolution.value.Location) {
        showConfirmModal.value = true;
      } else {
        selectedTab.value = defaultTab;
        if (!resolution.value.Location) {
          message.error("請輸入地點");
        }
        if (!resolution.value.FianlSchedularId) {
          message.error("請選擇時間");
        }
      }
    }

    async function onPositiveClick() {
      //Post Request
      await store.dispatch(
        HosterModule.desc + HosterActions.SubmitResolution,
        resolution.value
      );
      await store.dispatch(Module.desc + Actions.HandMyHostingEvents);
      store.dispatch(
        Module.desc + Actions.UpdateReloadParticipantEventsFlag,
        true
      );
      context.emit("showModalClose", false);
      setTimeout(() => (selectedTab.value = defaultTab), 1000);
    }

    function onNegativeClick() {}

    function datetimeString(date: string) {
      if (dayjs( date).format("MMDD") == dayjs( new Date()).format("MMDD"))
        return dayjs( date).format("HH:mm");
      else return dayjs( date).format("MM/DD");
    }

    function percentage(numerator: number, denominator: number) {
      return Number(((numerator * 100) / denominator).toFixed(0));
    }

    function stringColor(str: String, alpha: Boolean) {
      var colour = stc(str);
      return colour + (alpha ? "66" : "");
    }

    function ConfirmMessage() {
      return props.event.Status == ParamEventStatus.Open
        ? "確定結束投票?"
        : "確定送出";
    }
    function typeColor(status: any) {
      let result = "#dc0005";
      switch (status) {
        case ParamEventStatus.Open:
          result = "warning";
          headerStyle.background = themeVars.value.infoColor
          headerStyle.type = themeVars.value.warningColor
          break;
        case ParamEventStatus.Close:
          result = "info";
          headerStyle.background = themeVars.value.buttonColor2Pressed
          headerStyle.type = themeVars.value.infoColor
          break;
      }
      return result;
    }
    
    function tabType(id: number) {
      if (id == 0) {
        if (id == selectedTab.value)
          return null
        else
          return true
      } else if (id == 1) {
        if (id == selectedTab.value)
          return null
        else
          return true
      }
    }

    return {
      ParamIsResolution,
      showConfirmModal,
      bodyStyle,
      contentStyle,
      headerStyle,
      selectedTab,
      statusData,
      onClose,
      onReadyToSubmit,
      datetimeString,
      percentage,
      stringColor,
      ConfirmMessage,
      onPositiveClick,
      onNegativeClick,
      handleUpdateValue: (value: string) => {
        //selectedTab.value = value;
      },
      themeVars,
      ParamEventStatus,
      typeColor,
      changeColor,
      ParamResponseStatus,
      tabType
    };
  },
});
